var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-crud-tab__tab"},[(_vm.barShow && _vm.isShowSearch)?_c('div',{staticClass:"ioc-crud__search",staticStyle:{"padding":"18px 15px 0","background":"#fff"}},[_vm._t("form")],2):_vm._e(),_c('div',{staticClass:"ioc-crud__interval"})])
}
var staticRenderFns = []

export { render, staticRenderFns }